import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlarmAgentApiClient } from '.';

@Injectable({
	providedIn: 'root',
})
export class UserService {
	private API_ROUTE = 'users';

	constructor(private http: AlarmAgentApiClient) {}

	async getUsersPaginated(
		page: number,
		size: number,
		companyId: any,
		userId: any,
		groupId: any
	): Promise<PaginatedClass> {
		return this.http
			.get(
				`${this.API_ROUTE}/users?page=${page}&pageSize=${size}&companyId=${companyId}&userId=${userId}&groupId=${groupId}`
			)
			.toPromise();
	}

	async getUserById(userId: number, companyId: any): Promise<User> {
		return this.http
			.get(`${this.API_ROUTE}?userId=${userId}&companyId=${companyId}`)
			.toPromise();
	}

	async getUserFilter(companyId: any): Promise<UserManage[]> {
		return this.http
			.get(`${this.API_ROUTE}/getUserFilter?companyId=${companyId}`)
			.toPromise();
	}

	async saveUser(newUser: User): Promise<number> {
		return this.http.post(`${this.API_ROUTE}/update`, newUser).toPromise();
	}

	async getPrimaryContactForCompany(
		userName?: string,
		company?: string
	): Promise<number> {
		return this.http
			.get(
				`${this.API_ROUTE}/getPrimaryContactForCompany?userName=${userName}&company=${company}`
			)
			.toPromise();
	}

	async loginExists(
		loginName?: string,
		userId: number = 0,
		deactivateLoader = false
	): Promise<boolean> {
		return this.http
			.get(
				`${this.API_ROUTE}/loginExists?loginName=${loginName}&id=${userId}`,
				{
					headers: {
						'deactivate-loader': deactivateLoader
							? 'true'
							: 'false',
					},
				}
			)
			.toPromise();
	}

	async verifyLoginIsAvailable(
		loginName?: string,
		userId?: number
	): Promise<boolean> {
		return this.http
			.get(
				`${this.API_ROUTE}/verifyLoginIsAvailable?loginName=${loginName}&id=${userId}`
			)
			.toPromise();
	}

	async getUserTypes(): Promise<GenericClass[]> {
		return this.http
			.get(`${this.API_ROUTE}/notificationMethods`)
			.toPromise();
	}

	async saveUsers(newUser: UserManage): Promise<number> {
		return this.http
			.post(`${this.API_ROUTE}/updateUsers`, newUser)
			.toPromise();
	}

	async deleteUser(user: User): Promise<User> {
		return this.http.delete(`${this.API_ROUTE}/${user.id}`).toPromise();
	}

	/**
	 * Gets the user to delete.
	 * @param companyId the company ID.
	 * @param phoneNumber the phone number.
	 * @param email the email address.
	 * @returns Observable<any>
	 */
	getUserFiltered(
		companyId: number = 0,
		phoneNumber: string = '',
		email: string = '',
		phone: string = '',
		name: string = '',
		login: string = '',
		accessLevel: number = 0
	): Observable<User[]> {
		return this.http.get(
			`${this.API_ROUTE}/filter?companyId=${companyId ?? 0}
			&phoneNumber=${phoneNumber}
			&email=${email}
			&phone=${phone}
			&name=${name}
			&login=${login}
			&accessLevel=${accessLevel}
			`,
			{
				headers: {
					'deactivate-loader': 'true',
				},
			}
		);
	}

	/**
	 * Delete the users in the list.
	 * @param users the users to delete.
	 * @returns Observable<any>
	 */
	deleteUsers(users: number[]): Observable<any> {
		return this.http.post(`${this.API_ROUTE}/delete`, users);
	}

	/**
	 * Update the users ordinal.
	 * @param users the users to update.
	 * @returns Observable<any>
	 */
	ordinalUpdate(users: User[]): Observable<any> {
		return this.http.put(`${this.API_ROUTE}/ordinal-update`, users);
	}
}

export class User {
	id?: any;
	userName?: string;
	login?: string;
	password?: string;
	pin?: string;
	title?: string;
	companyId?: string;
	companyName?: string;
	phone?: string;
	email?: string;
	emailSecondary?: string;
	sms?: string;
	cell?: string;
	pager?: string;
	pagerCarrierId?: any;
	pagerCarrierValue?: number;
	phone2?: string;
	contactMethodId?: number;
	timezone?: string;
	accessLevel?: any;
	primaryContact?: any;
	mapViewOnLogin?: any;
	userType?: any;
	userTypeDescription?: string;
	allowManualRelayControl?: any;
	ordinal?: any;
	subscribedToRenewalEmail?: boolean;
}

export class UserManage {
	id: number = 0;
	userName: string = '';
	title?: string;
	userType?: string;
	userTypeName?: string;
	primaryContact?: any;
	groups?: any;
	ordinal?: any;
	isModified: boolean = false;
}

export class PaginatedClass {
	count: number = 0;
	page: number = 1;
	pageSize?: number;
	data?: any[];
}

export class UserGroup {
	id?: number;
	userName?: string;
	title?: string;
	userType?: string;
	group?: any;
	ordinal?: any;
}

export class GenericClass {
	id?: number;
	name: string = '';
}
